module.exports = __webpack_public_path__ + "img/04.57203e5d.png";